import { Button, Card, Form, Text } from "../../../../components";
import Localization from "../../../../localization";
import { Enums } from "../../../../utils";
import React, { useState } from "react";
import { Flex } from "antd";

const urlRegex = new RegExp(
  /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/gi
);

const ConfigurationForm = React.forwardRef(
  (
    { webhook, onSave = () => {}, close = () => {}, onTest = async () => "" },
    ref
  ) => {
    const method = Form.useWatch("method", ref.current ?? {});
    const [logs, setLogs] = useState("");

    return (
      <div>
        <Form
          ref={ref}
          initialValues={{
            ...webhook,
            method: webhook?.method ?? Enums.webhookMethods.get,
          }}
          fields={[
            {
              name: "url",
              label: Localization.general.webhook_url,
              placeholder: Localization.placeholder.webhook_url,
              rules: [
                {
                  required: true,
                  pattern: urlRegex,
                  message: Localization.feedback.enter_valid_url,
                },
              ],
            },
            {
              face: "select",
              name: "method",
              label: Localization.general.method,
              defaultValue: Enums.webhookMethods.get,
              options: Object.keys(Enums.webhookMethods)
                .map((key) => Enums.webhookMethods[key])
                .map((value) => ({
                  value,
                  label: value,
                })),
            },
            method === Enums.webhookMethods.post && {
              name: "body",
              type: "textarea",
              value: webhook.body,
              autoSize: { minRows: 7, maxRows: 10 },
              label: Localization.general.request_body,
              placeholder: Localization.placeholder.request_body,
            },
          ].filter(Boolean)}
        />
        <Button
          className="m-25-t"
          title={Localization.general.test_integration}
          onClick={async () => setLogs(await onTest())}
        />
        {!!logs && (
          <Card
            bordered
            className="m-20-t m-5-b"
            children={<Text children={logs} type="secondary" weight="400" />}
          />
        )}
        <Flex className="m-25-t" gap={"1rem"}>
          <Form.Submit
            type="primary"
            title={Localization.general.save_and_close}
            onClick={onSave}
          />
          <Button title={Localization.general.cancel} onClick={() => close()} />
        </Flex>
      </div>
    );
  }
);

export default ConfigurationForm;
